import createDeepEqualSelector from 'utils/reselect/typescript/createDeepEqualSelector';
import get from 'lodash.get';

import { selectEntities } from 'services/entities/selectors';
import { makeSelectSprayEventForSubmissionEntities } from 'services/sprayEventsForSubmission/selectors';

const selectEntityNames = createDeepEqualSelector(
    makeSelectSprayEventForSubmissionEntities(),
    selectEntities,
    (sprayEventEntities, entities) =>
        sprayEventEntities &&
        sprayEventEntities
            .map((item) => get(entities, [item.id, 'name']))
            .sort()
            .join(', ')
);

const makeSelectEntityNames = (): typeof selectEntityNames => selectEntityNames;

export { makeSelectEntityNames };
